import {
  GetProductColorSelloutParams,
  GetSelloutSummaryFromQuantityParams,
  SelloutProductColor,
  SelloutSummary,
  SelloutTotalsProductColor,
  SelloutTotalsProductColorMap,
  TotalsSelloutProductColorParams,
} from './product-color-sellout.types';

export const availableToShowSellout = (quantitySold: number, minValue?: number) => {
  if (minValue) {
    return minValue && quantitySold >= +minValue;
  }

  return quantitySold > 0;
};

export const getProductColorSellout = ({
  isFetching,
  minValue,
  metrics,
}: GetProductColorSelloutParams): SelloutProductColor | undefined => {
  if (isFetching || !metrics) {
    return;
  }

  return availableToShowSellout(metrics.totalSold, minValue) ? metrics : undefined;
};

export const getSelloutSummaryFromQuantity = ({
  isFetching,
  quantitySold,
  minValue,
}: GetSelloutSummaryFromQuantityParams): SelloutSummary => {
  if (isFetching || !quantitySold || !availableToShowSellout(quantitySold, minValue)) {
    return { totalQuantitySold: 0, hasSelloutValues: false };
  }

  return {
    totalQuantitySold: quantitySold,
    hasSelloutValues: quantitySold > 0,
  };
};

export const findTotalsSelloutProductColor = ({
  isFetching,
  productColorId,
  minValue,
  selloutTotalsMap,
}: TotalsSelloutProductColorParams): SelloutSummary => {
  if (isFetching || !selloutTotalsMap.size) {
    return { totalQuantitySold: 0, hasSelloutValues: false };
  }

  return getSelloutSummaryFromQuantity({
    isFetching,
    quantitySold: selloutTotalsMap.get(productColorId),
    minValue,
  });
};

export const mapSelloutProductColorsTotals = (
  totals: SelloutTotalsProductColor[],
): SelloutTotalsProductColorMap =>
  new Map(totals.map((item) => [item.productColorId, item.totalQuantitySold]));
